import React, { FC, memo } from 'react';
import { SC } from '../../styles/theme';
import { useAccountMenu } from '@hooks/useAccountMenu';
import { MenuItem } from '../MyAccountMenuItem';
import sessionInfoApi from '../../services/core/seassionInfoApi.service';
import { getSessionIdCookie } from '@utils/Session.utils';
import routes from '../../constants/routes';
import { IS_B2C, IS_CLIENT } from '../../constants/main';
import { useDispatch } from 'react-redux';
import UserDuck from '../../redux/user/user.duck';
import { BRANDID_LOGOUT_URL } from '../../constants/myAccount';
import { useFeatureSwitch } from 'src/hooks/useFeatureSwitch';

export const MenuTemplate: FC<SC> = memo(({ className }) => {
    const { menuItems } = useAccountMenu();
    const { isMyAccountOrdersDisabled } = useFeatureSwitch();
    const dispatch = useDispatch();

    const logoutUser = async () => {
        await sessionInfoApi.logout(getSessionIdCookie());
        dispatch(UserDuck.actionSetUserLogged(false));

        if (IS_CLIENT) {
            window.location.href = BRANDID_LOGOUT_URL.replace(
                '{redirectUrlLogout}',
                `${window.location.host}${routes.ROOT}`
            );
        }
    };

    return (
        <div className={className}>
            <nav>
                <ul>
                    {menuItems.map(item => {
                        if (item.id !== 'my-orders' || !isMyAccountOrdersDisabled)
                            return <MenuItem key={item.id} {...item} />;
                    })}

                    <MenuItem
                        type="click"
                        id="logout"
                        // @ts-ignore
                        label={`myaccount.logout${IS_B2C ? '.b2c' : ''}`}
                        onClick={logoutUser}
                        dataTestId="TESTING_LOGOUT_SIDEMENUITEM"
                    />
                </ul>
            </nav>
        </div>
    );
});
MenuTemplate.displayName = 'MenuTemplate';
